import { HeadersOptionsType } from "@/types/ModuleOptionsType";
import { ParentsType } from "@/wp/getParentPages.ts";
import styles from "./TeamHeader.module.scss";
import { Breadcrumbs } from "@/components/Breadcrumbs/Breadcrumbs";
import { Post } from "@/wp/types/client";
import { ImageType } from "@/types/baseTypes";
import { Headline } from "@/components/Headline/Headline";
import { BlogPostHeader } from "@/components/Header/BlogPostHeader/BlogPostHeader.tsx";
import { MediaItemResponsive } from "@/components/MediaItem/MediaItemResponsive";
import { ContentTag } from "@/components/ContentTag/ContentTag.tsx";

export interface TeamHeaderProps {
  post: Post<"team">;
  headerOptions?: HeadersOptionsType["header_team"];
  parents: ParentsType;
  fallbackImg?: ImageType | false;
}

export const TeamHeader = ({
  post,
  headerOptions,
  parents,
  fallbackImg,
}: TeamHeaderProps) => {
  const header = post.acf.header_team;
  const {
    background_color_class,
    image,
    seo_settings: { breadcrumb_title } = {},
  } = header;

  const { show_fallback_image, breadcrumb_position, splitheader } =
    headerOptions ?? {};

  const { text_vertical_align } = splitheader || {};

  const breadcrumbsJSX = (
    <div className="nav-oriented-breadcrumbs">
      <Breadcrumbs
        parents={parents}
        // post={post}
        breadcrumbPositon={
          breadcrumb_position
            ? breadcrumb_position
            : "is-justify-content-flex-start"
        }
        breadcrumbTitle={breadcrumb_title}
      />
    </div>
  );

  const mediaJSX = image ? (
    <MediaItemResponsive
      className={styles["landscape-image"]}
      image_desktop={image}
      sizes="(max-width: 767px) 50vw, 100vw"
      priority={true}
    />
  ) : (
    show_fallback_image &&
    fallbackImg && (
      <MediaItemResponsive
        className={styles["landscape-image"]}
        image_desktop={fallbackImg}
        sizes="(max-width: 767px) 50vw, 100vw"
        priority={true}
      />
    )
  );

  const contentJSX = (
    <div className={styles["content"]} data-text-align={text_vertical_align}>
      <span>
        {header.position && (
          <span className={styles.position}>{header.position}</span>
        )}
        {header.position && header.company_location && <span>, </span>}
        {header.company_location && (
          <span className={styles.location}>{header.company_location}</span>
        )}
      </span>
      <Headline
        headline={`${header.firstname} ${header.name}`}
        headline_html_tag="h1-posts"
        disableAnimation
      />
      {mediaJSX}
      {header.content && (
        <ContentTag extraClass="intro-text" content={header.content} />
      )}
    </div>
  );

  return (
    <BlogPostHeader
      breadcrumbsJSX={breadcrumbsJSX}
      contentJSX={contentJSX}
      sectionClassName={`${background_color_class}`}
    />
  );
};
